<foehn-page
    [appTitle]="appTitle"
    [etapeId]="etapeId"
    [statusProgressBarHidden]="true"
>
    <router-outlet></router-outlet>
</foehn-page>
